var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderLeftArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "38.132px",
    height: "63.504px",
    viewBox: "0 0 38.132 63.504",
    enableBackground: "new 0 0 38.132 63.504",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard-66") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E29C00",
    d: "M31.711,63.505c-1.683,0-3.294-0.668-4.483-1.858L1.857,36.275c-2.476-2.478-2.476-6.492,0-8.969 l25.371-25.37c2.434-2.52,6.449-2.59,8.969-0.156c2.52,2.434,2.589,6.449,0.154,8.969c-0.051,0.053-0.103,0.104-0.154,0.156 L15.31,31.79l20.887,20.887c2.476,2.478,2.476,6.494-0.002,8.97C35.005,62.837,33.394,63.505,31.711,63.505z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLeftArrow);
export default __webpack_public_path__ + "static/media/slider-left-arrow.db1b08d7bae5e372a5e8c72cae35cc73.svg";
export { ForwardRef as ReactComponent };